import React from "react";
import moment from "moment-timezone";
import uniq from "lodash/uniq";
import Select from "components/common/Select";
const renderOption = (option) => {
  if (!option.disabled) {
    return /* @__PURE__ */ React.createElement("span", { key: option.value, title: option.value }, "\xA0 ", option.label);
  }
  return /* @__PURE__ */ React.createElement("span", { key: option.value, title: option.value }, option.label);
};
class TimezoneSelect extends React.Component {
  constructor() {
    super(...arguments);
    // Some time zones are not stored into any areas, this is the group we use to put them apart in the dropdown
    // https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
    this._UNCLASSIFIED_AREA = "Unclassified";
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.getValue = () => this.timezone.getValue();
    this._formatTimezones = () => {
      const timezones = {};
      moment.tz.names().forEach((timezone) => {
        const splitted = timezone.split("/");
        const area = splitted.length > 1 ? splitted[0] : this._UNCLASSIFIED_AREA;
        const location = splitted.length > 1 ? splitted[1] : splitted[0];
        if (!timezones[area]) {
          timezones[area] = [];
        }
        timezones[area].push(location);
      });
      const labels = [{ label: "Browser's time zone", value: "" }];
      Object.keys(timezones).sort().forEach((area) => {
        labels.push({ label: area, disabled: true, value: area });
        const effectiveTimezones = uniq(timezones[area]).sort();
        const timezoneLabels = effectiveTimezones.map((location) => {
          const timezone = area === this._UNCLASSIFIED_AREA ? location : `${area}/${location}`;
          return { value: timezone, label: location.replace("_", " ") };
        });
        labels.push(...timezoneLabels);
      });
      return labels;
    };
  }
  render() {
    const timezones = this._formatTimezones();
    const { onChange, ...otherProps } = this.props;
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        ref: (timezone) => {
          this.timezone = timezone;
        },
        ...otherProps,
        inputId: "timezone-select",
        onChange,
        placeholder: "Pick a time zone",
        options: timezones,
        optionRenderer: renderOption
      }
    );
  }
}
TimezoneSelect.defaultProps = {
  onChange: () => {
  }
};
export default TimezoneSelect;
